/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var UsageGray = function UsageGray(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Empty state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['usage--gray-1', 'usage--gray-2', 'usage--gray-3', 'usage--gray-4', 'usage--gray-5', 'usage--gray-6', 'usage--gray-7', 'usage--gray-8', 'usage--gray-9', 'usage--gray-10', 'usage--gray-11', 'usage--gray-12', 'usage--gray-13', 'usage--gray-14', 'usage--gray-15', 'usage--gray-16', 'usage--gray-17', 'usage--gray-18'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 140 200",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: gradientIds['usage--gray-1'],
    d: "M0 0h140v200H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: gradientIds['usage--gray-2']
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#usage--gray--SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#usage--gray--SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v200H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-3'],
    gradientUnits: "userSpaceOnUse",
    x1: "66",
    y1: "168.463",
    x2: "66",
    y2: "-53.378",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#f5f5f5",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".466",
    stopColor: "#cdcdcd",
    stopOpacity: ".467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".814",
    stopColor: "#b4b4b4",
    stopOpacity: ".815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#ababab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#ababab"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.3 193.9L.2 155.7 0 38.5 66.1.3l65.7 38.2.2 117.2-65.7 38.2z",
    opacity: ".36",
    fill: "url(#".concat(gradientIds['usage--gray-3'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-4'],
    gradientUnits: "userSpaceOnUse",
    x1: "112.91",
    y1: "15.377",
    x2: "17.413",
    y2: "78.55",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".999",
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132 155.7l-65.7 38.2-66-38.2 65.6-38.1 66.1 38.1z",
    opacity: ".21",
    fill: "url(#".concat(gradientIds['usage--gray-4'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-5'],
    gradientUnits: "userSpaceOnUse",
    x1: "91.626",
    y1: "55.922",
    x2: "19.417",
    y2: "85.329",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#484848",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78 141.4l10.3.7v5.1L78 141.4z",
    fill: "url(#".concat(gradientIds['usage--gray-5'], ")"),
    fillOpacity: "0.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-6'],
    gradientUnits: "userSpaceOnUse",
    x1: "76.859",
    y1: "48.772",
    x2: "4.649",
    y2: "78.179",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#484848",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.2 148.6l10.3.7v5.1l-10.3-5.8z",
    fill: "url(#".concat(gradientIds['usage--gray-6'], ")"),
    fillOpacity: "0.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-7'],
    gradientUnits: "userSpaceOnUse",
    x1: "60.862",
    y1: "40.347",
    x2: "-11.347",
    y2: "69.754",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#484848",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 157l10.3.7v5.1L47.2 157z",
    fill: "url(#".concat(gradientIds['usage--gray-7'], ")"),
    fillOpacity: "0.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-8'],
    gradientUnits: "userSpaceOnUse",
    x1: "45.851",
    y1: "32.435",
    x2: "-26.359",
    y2: "61.843",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#484848",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 164.9l10.3.8v5.1l-10.3-5.9z",
    fill: "url(#".concat(gradientIds['usage--gray-8'], ")"),
    fillOpacity: "0.13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-9'],
    gradientUnits: "userSpaceOnUse",
    x1: "66.322",
    y1: "24.156",
    x2: "132",
    y2: "24.156",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132 155.7l-.1 6.2L66.3 200v-6.1l65.7-38.2z",
    opacity: ".52",
    fill: "url(#".concat(gradientIds['usage--gray-9'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-10'],
    gradientUnits: "userSpaceOnUse",
    x1: ".234",
    y1: "24.156",
    x2: "66.322",
    y2: "24.156",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#bbb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.3 193.9v6.1L.2 161.9l.1-6.2 66 38.2z",
    opacity: ".42",
    fill: "url(#".concat(gradientIds['usage--gray-10'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-11'],
    gradientUnits: "userSpaceOnUse",
    x1: "84.4",
    y1: "101.077",
    x2: "58.46",
    y2: "56.147",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.3 92.2l4.2 2.4v59.9l-4.2-2.4V92.2z",
    fill: "url(#".concat(gradientIds['usage--gray-11'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-12'],
    gradientUnits: "userSpaceOnUse",
    x1: "86.303",
    y1: "113.241",
    x2: "65.663",
    y2: "46.271",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 94.6l4.2-2.4v59.9l-4.2 2.4V94.6z",
    fill: "url(#".concat(gradientIds['usage--gray-12'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M69.3 92.2l4.2-2.4 4.2 2.4-4.2 2.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-13'],
    gradientUnits: "userSpaceOnUse",
    x1: "67.259",
    y1: "87.326",
    x2: "43.917",
    y2: "46.896",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 106.7l4.2 2.4V163l-4.2-2.4v-53.9z",
    fill: "url(#".concat(gradientIds['usage--gray-13'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-14'],
    gradientUnits: "userSpaceOnUse",
    x1: "66.476",
    y1: "97.128",
    x2: "53.017",
    y2: "36.724",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.7 109.1l4.2-2.4v53.9l-4.2 2.4v-53.9z",
    fill: "url(#".concat(gradientIds['usage--gray-14'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M53.5 106.7l4.2-2.4 4.2 2.4-4.2 2.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-15'],
    gradientUnits: "userSpaceOnUse",
    x1: "100.24",
    y1: "112.376",
    x2: "72.283",
    y2: "63.954",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.2 80.3l4.2 2.4v64.6l-4.2-2.4V80.3z",
    fill: "url(#".concat(gradientIds['usage--gray-15'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-16'],
    gradientUnits: "userSpaceOnUse",
    x1: "113.016",
    y1: "127.229",
    x2: "73.394",
    y2: "58.608",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.4 82.8l4.2-2.4V145l-4.2 2.4V82.8z",
    fill: "url(#".concat(gradientIds['usage--gray-16'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M84.2 80.3l4.2-2.4 4.2 2.4-4.2 2.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-17'],
    gradientUnits: "userSpaceOnUse",
    x1: "50.02",
    y1: "71.172",
    x2: "30.818",
    y2: "37.913",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3 124.1l4.2 2.4v44.3l-4.2-2.4v-44.3z",
    fill: "url(#".concat(gradientIds['usage--gray-17'], ")")
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['usage--gray-18'],
    gradientUnits: "userSpaceOnUse",
    x1: "45.418",
    y1: "77.108",
    x2: "43.702",
    y2: "28.617",
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ededed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".001",
    stopColor: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 126.5l4.2-2.4v44.3l-4.2 2.4v-44.3z",
    fill: "url(#".concat(gradientIds['usage--gray-18'], ")")
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M38.3 124.1l4.2-2.4 4.2 2.4-4.2 2.4z"
  })));
};
UsageGray.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var UsageGray$1 = UsageGray;

export { UsageGray$1 as default };
